import { render, staticRenderFns } from "./ElementStudioAdditionalClasses.vue?vue&type=template&id=042c0e66&"
import script from "./ElementStudioAdditionalClasses.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioAdditionalClasses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports